import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { Sparkles, X, ArrowRight } from "lucide-react";
import "../../styles/subscription.css";

/**
 * Global upgrade prompt. Opens on:
 *   - window "subscription:upgrade" events (FeatureGuard buttons)
 *   - HTTP 402 responses (api.js interceptor dispatches the same event)
 */
export default function UpgradeModal() {
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);

  useEffect(() => {
    const handler = (e) => setInfo(e.detail || {});
    window.addEventListener("subscription:upgrade", handler);
    return () => window.removeEventListener("subscription:upgrade", handler);
  }, []);

  if (!info) return null;

  const title = info.error === "limit_reached" ? "Plan limit reached" : "Feature not in your plan";
  const message =
    info.message ||
    (info.feature
      ? `Your current plan doesn't include “${info.feature}”.`
      : "Upgrade your plan to continue.");

  return createPortal(
    <div className="sub-modal-overlay" role="dialog" aria-modal="true" onClick={() => setInfo(null)}>
      <div className="sub-modal" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="sub-modal-x" onClick={() => setInfo(null)} aria-label="Close"><X size={18} /></button>
        <div className="sub-modal-badge"><Sparkles size={26} /></div>
        <h3 className="sub-modal-title">{title}</h3>
        <p className="sub-modal-text">{message}</p>
        {info.metric ? (
          <div className="sub-modal-meter">Used {info.used} of {info.limit} {String(info.metric).replace(/_/g, " ")}</div>
        ) : null}
        <div className="sub-modal-actions">
          <button type="button" className="sub-btn sub-btn-ghost" onClick={() => setInfo(null)}>Not now</button>
          <button type="button" className="sub-btn sub-btn-primary" onClick={() => { setInfo(null); navigate("/settings/subscription"); }}>
            View plans <ArrowRight size={15} />
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
